const routes = {
    path: 'impressoras',
    name: 'Checkins_Impressoras',
    component: () => import('./Impressoras.vue'),
    children: [
        {
            path: 'dashboard',
            name: 'Checkins_Impressoras_Dashboard',
            component: () => import('./Dashboard.vue'),
            meta: {
                rules: ['CHECKINS-EVENTOS-15'],
            },
        },
    ],
    meta: {
        rules: ['CHECKINS-EVENTOS-15'],
    },
};

export default routes;
